import { Grid, Card, Typography, Checkbox, Button } from '@mui/joy';
import {patch, post} from "../api/api";
import Swal from "sweetalert2";

const EventBoost = ({ event }: { event: any }) => {
    const sleep = (ms: number | undefined) => new Promise(r => setTimeout(r, ms));
    const onBoost = async (status: boolean) => {
        patch({
            url: `events/${event.id}`, data: {
                boosted: status
            },
        }).then(async (res) => {
            if (res.status === 200) {
                Swal.fire({
                    title: 'Succès',
                    text: `Le boost a bien été ${status ? 'appliqué' : 'enlevé'}.`,
                    icon: 'success',
                });
            }
            await sleep(1000);
            window.location.reload();
        });
    }
  return (
    <Card variant="outlined">
      <Typography level="title-lg">Souhaitez-vous booster cet évènement ?</Typography>
      <Grid xs={4}>
        {event.boosted ?
          <Button onClick={() => onBoost(false)} color="danger">
            Arrêter le boost
          </Button>
          :
          <Button onClick={() => onBoost(true)}>
            Booster l'évènement
          </Button>
        }
      </Grid>
    </Card>
  );
};

export default EventBoost;
